import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter
} from '@angular/core';

import { MatDatepickerInputEvent } from "@angular/material";

@Component({
  selector: 'rm-app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.css']
})
export class DatepickerComponent implements OnInit {

  public minDate: any;
  events: string[] = [];
  // public date:any;
  @Input() label: string = '';
  @Input() exp: any;
  @Input() dateValue: string=''; 
  @Input() date = new Date();
  @Input() disableIcon:boolean;
  // @Output()  value=new EventEmitter<Date>();
  @Output() selectedDateChange = new EventEmitter<Date>();

  constructor(){}

  ngOnInit() {
    // console.log(this.dateValue);
  }

  onDateChange(type: string, event: MatDatepickerInputEvent<Date>) {

    this.selectedDateChange.emit(event.value);
    // console.log(event.value);
  }

  addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    // this.events.push(`${type}: ${event.value}`);
  }

}
